module.exports = __webpack_public_path__ + "img/cities.d915de33.svg";